import {
  Component,
  OnInit,
  ChangeDetectorRef,
  Inject,
  Optional,
} from '@angular/core';
import {
  MatBottomSheetRef,
  MAT_BOTTOM_SHEET_DATA,
} from '@angular/material/bottom-sheet';
import { HeaderComponent } from 'src/app/common/header/header.component';
import { MessageService } from 'src/app/common/services/message.service';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import { ApiService } from 'src/app/common/services/api.service';
import { CurrencyService } from 'src/app/util/currency.service';
import { UtilService } from 'src/app/util/util.service';
import { TranslateService } from '@ngx-translate/core';
import {
  CROSS_ICON_STAFF,
  CHECKED,
  PERSON,
  PHONE_2,
  OTHER_PLATEFORM,
  DINNING_ROOM,
} from 'src/defaultImages.js';
import { EventTrackerService } from 'src/app/common/services/event-tracker.service';
import { LocalStorageService } from 'src/app/common/services/localStorage.service';
import { OrderTypeEnum } from 'src/app/common/enums/order.enum';

@Component({
  selector: 'app-choose-ordertype',
  templateUrl: './choose-ordertype.component.html',
  styleUrls: ['./choose-ordertype.component.css'],
})
export class ChooseOrdertypeComponent implements OnInit {
  images = { 
    CROSS_ICON_STAFF: CROSS_ICON_STAFF,
    CHECKED: CHECKED,
    PERSON: PERSON,
    PHONE_2: PHONE_2,
    OTHER_PLATEFORM: OTHER_PLATEFORM,
    DINNING_ROOM: DINNING_ROOM
  };
  Currency;
  orderType = [];
  modalState = {
    orderDetails: 1,
    customerDetails: 0,
    tableDetails: 0,
  };
  validOrderType = {
    orderDetails: 1,
    customerDetails: 1,
    tableDetails: 1,
  };
  currentItemName: string = '';
  customerForm: FormGroup;
  allSections: any[] = [];
  selectedFloorTables = [];
  selectedSection: string;
  selectedSectionName: string;
  currentTableId: string = '';
  tableLoader: boolean = false;
  currentOrderType: any;
  serverObj: any = {};
  table: { table_id: any; table_no: any };
  inputData: any;
  isPhoneNumLength13Chars: boolean = false;
  constructor(
    private _bottomSheetRef: MatBottomSheetRef<any>,
    private messageService: MessageService,
    @Optional() @Inject(MAT_BOTTOM_SHEET_DATA) public data: any,
    private fb: FormBuilder,
    private apiService: ApiService,
    private cd: ChangeDetectorRef,
    private utilService: UtilService,
    private curr: CurrencyService,
    public translateService: TranslateService,
    private _eventTracker: EventTrackerService,
    private _localStorage: LocalStorageService
  ) {
    this.Currency = this.curr.getCurrency();
    this.customerForm = this.fb.group({
      name: [''],
      dial_code: [localStorage.getItem('pos_dial_code')],
      number: [''],
      user_gender: [localStorage.getItem('user_gender')],
      user_dob: [localStorage.getItem('user_dob')],
    });
  }

  ngOnInit() {
    this.getOrderTypeListDetails();
    // this.orderType = this.utilService.get_pos_order_type();
    this.get_tables();
    this.inputData = this.data;
    let mobileno = localStorage.getItem('pos_number');
    if (localStorage.getItem('pos_no_enter') == '0') {
      mobileno = '';
    }
    this.customerForm.patchValue({
      name: localStorage.getItem('pos_username'),
      dial_code: localStorage.getItem('pos_dial_code'),
      number: mobileno,
      user_gender: localStorage.getItem('user_gender'),
      user_dob: localStorage.getItem('user_dob'),
    });
    // this.orderType.forEach(item => {
    //   if(item.id.toString() == localStorage.getItem('pos_order_type') && item.platform == localStorage.getItem('pos_platform')){
    //     this.orderTypeClicked(item);
    //   }
    // });
    this.checkValidForm();
    this.listenPhoneNumChange();
  }
  getOrderTypeListDetails() {
    const param = new FormData();
    param.append('restaurant_id', localStorage.getItem('restaurant_id'));
    this.apiService.getRestaurantDetails(param).subscribe((res: any) => {
      if (res.status == 1) {
        const orderTypeList = this.utilService.prepareOrderTypeList(
          res.data.offline_platforms
        );
        this.orderType = this.utilService.get_pos_order_type(orderTypeList);
        this.orderType.forEach((item) => {
          if (
            item.id.toString() == localStorage.getItem('pos_order_type') &&
            item.platform == localStorage.getItem('pos_platform')
          ) {
            this.orderTypeClicked(item);
          }
        });
        this.cd.detectChanges();
      }
    });
  }
  dismiss(): void {
    this._bottomSheetRef.dismiss({
      data: null,
      message: 'closed',
      status: 0,
    });
    event.preventDefault();
  }

  checkValidForm() {
    let from = this.inputData.from;
    let action = this.inputData.action;
    let curr_order = localStorage.getItem('pos_order_id');
    this.modalState.orderDetails = 0;
    this.modalState.customerDetails = 0;
    this.modalState.tableDetails = 0;
    if (from == 'order') {
      this.validOrderType = {
        orderDetails: 1,
        customerDetails: 0,
        tableDetails: 0,
      };
      this.modalState.orderDetails = 1;
    } else if (from == 'cart' || from == 'menu') {
      if (action == 'table') {
        this.validOrderType = {
          orderDetails: 0,
          customerDetails: 0,
          tableDetails: 1,
        };
        this.modalState.tableDetails = 1;
      } else if (action == 'menu') {
        this.validOrderType = {
          orderDetails: 1,
          customerDetails: 0,
          tableDetails: 0,
        };
        this.modalState.orderDetails = 1;
      } else if (action == 'create' || action == 'settle') {
        this.validOrderType = {
          orderDetails: 0,
          customerDetails:
            localStorage.getItem('pos_user_details_set') == '1' ? 0 : 1,
          tableDetails: localStorage.getItem('pos_table_no_set') == '1' ? 0 : 1,
        };
        if (this.validOrderType.customerDetails) {
          this.modalState.customerDetails = 1;
        } else {
          this.modalState.tableDetails = 1;
        }
      } else {
        let pos_platform = localStorage.getItem('pos_platform');
        if (
          (localStorage.getItem('pos_user_details_set') == '1' &&
            localStorage.getItem('pos_table_no_set') == '1') ||
          pos_platform !== 'easyeat' ||
          (localStorage.getItem('pos_user_details_set') == '1' &&
            localStorage.getItem('pos_order_type') !== '0')
        ) {
          this.validOrderType = {
            orderDetails: 1,
            customerDetails: 1,
            tableDetails: 1,
          };
          this.modalState.orderDetails = 1;
        } else {
          this.validOrderType = {
            orderDetails: 0,
            customerDetails:
              localStorage.getItem('pos_user_details_set') == '1' ? 0 : 1,
            tableDetails:
              localStorage.getItem('pos_table_no_set') == '1' ? 0 : 1,
          };
          if (this.validOrderType.customerDetails) {
            this.modalState.customerDetails = 1;
          } else if (this.validOrderType.tableDetails) {
            this.modalState.tableDetails = 1;
          } else {
            this.modalState.orderDetails = 1;
            this.validOrderType = {
              orderDetails: 1,
              customerDetails: 1,
              tableDetails: 1,
            };
          }
        }
      }
    }
  }

  get_tables() {
    this.tableLoader = true;
    const formData: any = new FormData();
    formData.append('token', localStorage.getItem('token'));

    this.apiService.getTables(formData).subscribe(
      (data: any) => {
        this.tableLoader = false;
        this.allSections = this.withoutDeletedSections(data?.all_tables?.floors);
        for (let i = 0; i < this.allSections.length; i++) {
          // restrict delivery/takeaway floor in dropdown (select table modal)
          if (this.allSections[i].floor_id === 'dlf') {
            this.allSections.splice(i, 1);
            break;
          }
        }
        if (!this.allSections.length) {
          this.selectedSection = null;
          this.selectedSectionName = null;
          this.selectedFloorTables = [];
          this.cd.detectChanges();
          return;
        }
        this.selectedSection = this.allSections[0].floor_id;
        this.selectedSectionName = this.allSections[0].floor_name;
        this.findSelectedFloorTables(this.selectedSection);
        this.tableClicked({
          table_id: localStorage.getItem('pos_table_id'),
          table_no: localStorage.getItem('pos_table_no'),
        });
        this.cd.detectChanges();
      },
      (error: any) => {
        this.tableLoader = false;
      }
    );
  }

  orderTypeClicked(item) {
    this.currentItemName = item.name;
    this.currentOrderType = item;
  }

  proceed(type) {
    this.modalState = {
      orderDetails: 0,
      customerDetails: 0,
      tableDetails: 0,
    };
    if (type == 'order') {
      this.serverObj['orderType'] = this.currentOrderType;
      this.setLocalStorageItems('ot');
      if (this.currentOrderType.platform !== 'easyeat') {
        this.dismiss_bottomsheet();
      } else if (this.validOrderType.customerDetails == 1) {
        this.modalState.customerDetails = 1;
      } else if (this.validOrderType.tableDetails == 1) {
        this.modalState.tableDetails = 1;
      } else {
        this.dismiss_bottomsheet();
      }
    } else if (type == 'customer') {
      this.customerForm.markAllAsTouched();
      if (this.customerForm.valid) {
        this.serverObj['customer'] = this.customerForm.value;
        this.setLocalStorageItems('ud');
        if (
          this.currentOrderType.id == 0 &&
          this.validOrderType.tableDetails == 1
        ) {
          this.modalState.tableDetails = 1;
        } else {
          this.dismiss_bottomsheet();
        }
      }
    } else if (type == 'table') {
      this.serverObj['table'] = this.table;
      this.setLocalStorageItems('ut');
      this.dismiss_bottomsheet();
    }

    if (type == 'order') {
      this._eventTracker.easyeat_track_event('ORDER_TYPE_SELECTED', {
        'Order Source': 'POS-M',
        'Order Type': this.currentOrderType.id,
        'Order Platform': this.currentOrderType.platform,
      });
    } else if (type == 'customer') {
      this._eventTracker.easyeat_track_event('CUSTOMER_DETAILS_SAVED', {
        'Order Source': 'POS-M',
        'CUSTOMER NAME': this.customerForm.value.name,
        'DIAL CODE': this.customerForm.value.dial_code,
        'CUSTOMER MOBILE NUMBER': this.customerForm.value.number,
      });
    } else if (type == 'table') {
      this._eventTracker.easyeat_track_event('TABLE_NUM_SELECTED', {
        'Order Source': 'POS-M',
        FLOOR_NAME: this.selectedSectionName,
        TABLE_NUM: this.table.table_no,
      });
    }
  }

  changeFloor(id, name) {
    this.selectedSection = id;
    this.selectedSectionName = name;
  }

  dismiss_bottomsheet() {
    this._bottomSheetRef.dismiss({
      data: this.serverObj,
      message: 'changed',
      status: 1,
      action: this.inputData.action,
    });
  }

  setLocalStorageItems(type) {
    if (type == 'ot') {
      localStorage.setItem('pos_order_type_set', '1');
      this._localStorage.set('pos_order_type', this.serverObj.orderType.id);
      this._localStorage.set('pos_platform', this.serverObj.orderType.platform);
      localStorage.setItem('pos_ordertype_name', this.serverObj.orderType.name);
      if(this.serverObj?.orderType?.id === OrderTypeEnum.TAKEAWAY) {
        this._localStorage.set('pos_table_id', 'takeaway');
        this._localStorage.set('pos_table_no', 'takeaway');
      }
    } else if (type == 'ud') {
      localStorage.setItem('pos_user_details_set', '1');
      localStorage.setItem('pos_username', this.serverObj.customer.name);
      localStorage.setItem('pos_number', this.serverObj.customer.number);
      localStorage.setItem('pos_dial_code', this.serverObj.customer.dial_code);
      if (this.serverObj.customer.number.length < 3) {
        localStorage.setItem('pos_no_enter', '0');
      } else {
        localStorage.setItem('pos_no_enter', '1');
      }
    } else if (type == 'ut') {
      localStorage.setItem('pos_table_no_set', '1');
      localStorage.setItem('pos_table_id', this.serverObj.table.table_id);
      localStorage.setItem('pos_table_no', this.serverObj.table.table_no);
      localStorage.setItem('pos_floor_id', this.selectedSection);
    }
  }

  tableClicked(item) {
    this.table = {
      table_id: item.table_id,
      table_no: item.table_no,
    };
    this.currentTableId = item.table_id;
  }
  private withoutDeletedSections(floors: any[]): any[] {
    return (floors || [])
      .filter((floor) => Number(floor?.status) !== 9)
      .map((floor) => ({
        ...floor,
        tables: (floor?.tables || []).filter((table) => Number(table?.status) !== 9),
      }));
  }

  findSelectedFloorTables(floorid) {
    for (let item of this.allSections) {
      if (item.floor_id === floorid) {
        this.selectedFloorTables = item.tables;
        break;
      }
    }
  }
  change(id) {
    this.findSelectedFloorTables(id);
  }
  listenPhoneNumChange() {
    this.customerForm.get('number').valueChanges.subscribe((value) => {
      const phoneNumLength = value.length;
      if (phoneNumLength === 13) {
        this.isPhoneNumLength13Chars = true;
        setTimeout(() => {
          this.isPhoneNumLength13Chars = false;
          this.cd.detectChanges(); 
        }, 5000);
      }
    });
  }

  onPhoneInputChanges(e) {
    return e.charCode >= 44 && e.charCode <= 57 && e.charCode !== 47;
  }

  getButtonLabel(): string {
    const numberLength = this.customerForm.get('number').value.length || 0;
    const nameLength = this.customerForm.get('name').value.length || 0;

    if ((numberLength === 0 || numberLength > 8) && nameLength > 0) {
      return 'POS.CONTINUE';
    } else {
      return 'POS.SKIP';
    }
  }
}
